import { ThemeEvents, VariantUpdateEvent } from '@theme/events'
import { morph } from '@theme/morph'

class ProductInventory extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog')
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory)
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog')
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory)
  }

  /**
   * Updates the inventory.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInventory = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return
    }

    const newInventory = event.detail.data.html.querySelector('product-inventory')

    if (!newInventory) {
      // Hide the element if inventory is no longer low
      this.style.display = 'none'
      return
    }

    const newStyle = newInventory.getAttribute('style') || ''
    const isHidden = /\bdisplay\s*:\s*none\b/i.test(newStyle)

    if (isHidden) {
      this.style.display = 'none'
    } else {
      this.style.display = ''
    }

    morph(this, newInventory, { childrenOnly: true })
  }
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory)
}
